export const withdrawalWarning = ['Goerli Testnet'];
